import React from "react";
import { Header, Home, About, Projects, Contact } from "../components";

export default function Layout() {
  return (
    <>
      <Header />
      <Home />
      <About />
      <Projects />
      <Contact />
    </>
  );
}
